var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastV5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-mail-opened",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9l9 6l9 -6l-9 -6l-9 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19l6 -6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13l6 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastV5);
export default __webpack_public_path__ + "static/media/lastV5.389683758331e4c48b342df6cba50b9d.svg";
export { ForwardRef as ReactComponent };